enum API {
    POST_LOGIN = '/sys/login',
    POST_REGISTER = '/sys/register',
    POST_LOGIN_PHONE = '/sys/loginPhone',
    POST_SEND_CODE = '/sys/loginSendCode',
    POST_REGISTER_PHONE = '/sys/registerByPhone',
    POST_UPDATE_PROFILE = '/sys/updateProfile',
    GET_USER_INFO = '/sys/getUserInfo',
    GET_QUOTA = '/sys/quota',
    GET_LOGOUT = '/sys/logout',
    POST_BIND_ENTERPRISE = '/sys/bindEnterprise',
    GET_HISTORY_TITLE_LIST = '/conversation/history',
    POST_HISTORY_TITLE = '/conversation/addTitle',
    GET_UPLOAD = '/file/upload',
    POST_APP_UPLOAD_FILE = '/file/appUploadFile',
    POST_TEMP_FILE = '/file/uploadTempFile',
    GET_FILE_STATUS = '/file/upload',
    POST_FILE_LIST = '/file/fileList',
    POST_DELETE_FILE = '/file/deleteFile',
    POST_LIST_CATEGORY = '/category/listCategory',
    POST_ADD_CATEGORY = '/category/addCategory',
    POST_DELETE_CATEGORY = '/category/deleteCategory',
    POST_INDEX_INIT = '/index/init',
    POST_INDEX_STATUS = '/index/getIndexJobStatus',
    POST_CHAT_DEEPSEEK = '/chat/deepSeekForApp',
    GET_CHAT_QWAPP = '/chat/qwAppAnalysis',
    POST_CHAT_QWANALYSIS = '/chat/qwAnalysis',
    POST_CREATE_ENTERPRISE = '/enterprise/createEnterprise',
    POST_UPDATE_ENTERPRISE = '/enterprise/updateEnterprise',
    GET_ENTERPRISE_LIST = '/enterprise/getEnterpriseList',
    GET_ENTERPRISE_BRANDING = '/enterprise/branding',
    PUT_ENTERPRISE_BRANDING = '/enterprise/branding',
    GET_ENTERPRISE_CONFIG = '/enterprise/config',
    GET_ENTERPRISE_USERS = '/enterprise/users',
    PUT_ENTERPRISE_USER_ROLE = '/enterprise/users',
    GET_ENTERPRISE_QUOTA = '/enterprise/quota',
    GET_PLANS = '/plan/list',
    GET_CURRENT_PLAN = '/plan/current',
    GET_SUBSCRIPTION_INFO = '/subscription/info',
    POST_CREATE_ORDER = '/payment/createOrder',
    GET_PAYMENT_STATUS = '/payment/status',
    GET_PAYMENT_ORDERS = '/payment/orders',
    GET_ORDER_DETAIL = '/payment/order',
    POST_GET_PUBLIC_KEY = '/support/getPublicKey',
    POST_DICTIONARY = '/dictionary/getByType',

    // ---- Website Generator ----
    POST_WEBSITE_GENERATE = '/website/generate',
    GET_WEBSITE_STATUS = '/website/generate/status',
    GET_WEBSITE = '/website/get',
    PUT_WEBSITE = '/website/update',
    PUT_WEBSITE_SAVE = '/website/save',
    PUT_WEBSITE_BLOCK = '/website/block/update',
    POST_WEBSITE_BLOCK_ADD = '/website/block/add',
    DELETE_WEBSITE_BLOCK_DELETE = '/website/block/delete',
    POST_WEBSITE_PAGE_ADD = '/website/page/add',
    DELETE_WEBSITE_PAGE = '/website/page/delete',
    PUT_WEBSITE_PAGE_REORDER = '/website/page/reorder',
    GET_WEBSITE_CHAT_EDIT = '/website/chatEdit',
    POST_WEBSITE_PUBLISH = '/website/publish',
    POST_WEBSITE_UNPUBLISH = '/website/unpublish',
    GET_WEBSITE_PUBLIC = '/website/public',
    PUT_WEBSITE_BUTLER = '/website/butler/update',
    GET_WEBSITE_BUTLER_CHAT = '/website/butler/chat',
    GET_WEBSITE_ANALYTICS = '/website/analytics',
    GET_WEBSITE_AI_INSIGHTS = '/website/analytics/insights',
    GET_WEBSITE_TEMPLATE_LIST = '/website/template/list',
    GET_WEBSITE_TEMPLATE_DETAIL = '/website/template/',
    POST_WEBSITE_NAV_ADD = '/website/nav/add',
    PUT_WEBSITE_NAV_UPDATE = '/website/nav/update',
    DELETE_WEBSITE_NAV_DELETE = '/website/nav/delete',
    GET_WEBSITE_BRANDING = '/website/branding',
    PUT_WEBSITE_BRANDING_UPDATE = '/website/branding/update',

    // ---- Admin ----
    GET_ADMIN_STATUS = '/admin/status',
    GET_ADMIN_DASHBOARD = '/admin/dashboard',
    GET_ADMIN_CONFIG_LIST = '/admin/config/list',
    GET_ADMIN_CONFIG_DETAIL = '/admin/config/',
    POST_ADMIN_CONFIG_CREATE = '/admin/config/create',
    PUT_ADMIN_CONFIG_UPDATE = '/admin/config/update',
    DELETE_ADMIN_CONFIG_DELETE = '/admin/config/delete/',
    GET_ADMIN_ENTERPRISE_CONFIG = '/admin/config/enterprise/',
    POST_ADMIN_ENTERPRISE_CONFIG = '/admin/config/enterprise/',

    // ---- Admin Plan ----
    GET_ADMIN_PLAN_LIST = '/admin/plan/list',
    GET_ADMIN_PLAN_DETAIL = '/admin/plan/detail/',
    POST_ADMIN_PLAN_CREATE = '/admin/plan/create',
    PUT_ADMIN_PLAN_UPDATE = '/admin/plan/update',
    DELETE_ADMIN_PLAN_DELETE = '/admin/plan/delete/',
    PUT_ADMIN_PLAN_TOGGLE = '/admin/plan/toggle/',

    // ---- Admin Order ----
    GET_ADMIN_ORDER_LIST = '/admin/order/list',
    GET_ADMIN_ORDER_DETAIL = '/admin/order/',
}
export default API;